import React from 'react'
import Layout from '../Layout'
import ResourceForm from '../../../Components/ResourceForm'
import FormFieldController from '../../../Components/FormFieldController'
import BackLink from '../../../Components/BackLink'
import { courseSchema } from '../../../schemas'

export default function New({ account, accounts, navigation }) {
  return (
    <Layout
      account={account}
      accounts={accounts}
      navigation={navigation}
      title="New Course"
    >
      <BackLink href="/manage/courses">Back to Courses</BackLink>

      <div className="bg-white shadow rounded-lg">
        <ResourceForm
          schema={courseSchema}
          resource="course"
          endpoint="/manage/courses"
          backLink="/manage/courses"
          submitLabel="Create Course"
          defaultValues={{
            name: '',
            hole_count: 18
          }}
        >
          {({ control, errors }) => (
            <>
              <FormFieldController
                control={control}
                name="name"
                label="Name"
                required
                errors={errors}
                placeholder="e.g., Main Course"
              />

              <FormFieldController
                control={control}
                name="hole_count"
                label="Number of Holes"
                type="number"
                required
                errors={errors}
              />
            </>
          )}
        </ResourceForm>
      </div>
    </Layout>
  )
}
